import { Dialog } from './Dialog';
import { usePaywallStore } from '../store/paywall';
import { useT, type TFn } from '../i18n';
import type { ApiErrorCode } from '../api/client';

// ANX-105 — глобальный апселл при 402-лимите тарифа. Монтируется в AppShell;
// наполняется через onPaywall-хук ApiClient (см. api/factory.ts).
function paywallMessage(code: ApiErrorCode, t: TFn): string {
  switch (code) {
    case 'seat_limit_reached':
      return t('paywall.seat_limit_reached');
    case 'dialog_limit_reached':
      return t('paywall.dialog_limit_reached');
    default:
      return t('paywall.plan_required');
  }
}

export function PaywallDialog() {
  const t = useT();
  const code = usePaywallStore((s) => s.code);
  const close = usePaywallStore((s) => s.close);

  if (code === null) return null;

  return (
    <Dialog
      open
      onClose={close}
      title={t('paywall.title')}
      size="sm"
      footer={
        <a
          href="/billing"
          onClick={close}
          className="inline-block rounded bg-accent-600 px-3 py-2 text-sm font-medium text-white hover:bg-accent-700"
        >
          {t('paywall.cta')}
        </a>
      }
    >
      <p className="text-sm text-slate-700">{paywallMessage(code, t)}</p>
    </Dialog>
  );
}
